<template>
  <div class="mb-xs mt-3xs" v-if="environment != 'prod'">
    <div class="mb-xs mt-xs flex justify-center">
      <p id="mockarutan" @click="() => (showMockarutan = !showMockarutan)">
        Mockarutan
      </p>
    </div>
    <div class="mb-md mt-md flex justify-center gap-sm">
      <avtalat-button
        id="hamtadata"
        v-if="showMockarutan"
        icon="dator-1"
        @click="
          mockDataStore.fetchMockData(individStore.individ.data?.id!, apiClient)
        "
        small
        >Hämta data</avtalat-button
      >
      <avtalat-button
        id="sparadata"
        v-if="showMockarutan"
        icon="spargris"
        @click="onUpdateMockData()"
        small
        >Spara cache</avtalat-button
      >
      <avtalat-button
        id="aterstallanvandare"
        v-if="showMockarutan"
        icon="dodsfall"
        color="red"
        small
        @click="
          mockDataStore.clearMockData(individStore.individ.data?.id!, apiClient)
        "
        >Återställ användare</avtalat-button
      >
    </div>
    <Editor
      v-if="data && showMockarutan"
      :content="stringifiedData"
      :onChange="(content: Content) => onChange(content)"
    />
    <avtalat-spinner v-if="loading" />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from "pinia";
import {
  type Content,
  type JSONContent,
  type TextContent,
} from "vanilla-jsoneditor";
import { ref, watch } from "vue";

import { PlatformData } from "@/composables/KundserviceAppApiClient";
import { useApi } from "@/composables/useApi";
import { useIndividStore } from "@/stores";

import Editor from "./JsonEditor.vue";
import { useMockDataStore } from "./store/mockDataStore";
import { currentEnvironment } from "@/common/utils/currentEnvironment";

const environment = currentEnvironment();
const apiClient = useApi();
const individStore = useIndividStore();
const mockDataStore = useMockDataStore();
const { data, loading } = storeToRefs(mockDataStore);
const mockData = ref();
const stringifiedData = ref();
const showMockarutan = ref(false);

watch(
  () => mockDataStore.data,
  () => {
    const jsonData = JSON.parse(JSON.stringify(data?.value ?? {}));
    stringifiedData.value = {
      json: jsonData,
    };
    mockData.value = jsonData;
  },
  { immediate: true },
);

const onUpdateMockData = () => {
  const individId = individStore.individ.data?.id;
  mockDataStore.setMockData(
    individId!,
    mockData.value as PlatformData,
    apiClient,
  );
};

const onChange = (content: Content) => {
  mockData.value = (content as JSONContent).json
    ? (content as JSONContent).json
    : JSON.parse((content as TextContent).text);
};
</script>

<style scoped>
#mockarutan {
  cursor: pointer;
}
</style>
